export const GETSUBCATITEM = 'GETSUBCATITEM'
export const PRODUCT_ADDED = 'PRODUCT_ADDED'
export const PRODUCT_ADDED_ERROR = 'PRODUCT_ADDED_ERROR'
export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST'